import { useEffect, createRef } from 'react';
import styled from 'styled-components';

const SvgFromFilePathWrapper = styled.div`
  svg {
    max-width: 100%;
    width: auto;
    height: auto;
  }
`;

const SvgFromFilePath = ({ path, isDecorativeImage, ariaLabel }) => {
  const imageRef = createRef(null);

  useEffect(() => {
    if (imageRef.current.children.length === 0) {
      fetch(path)
        .then((res) => res.text())
        .then((data) => {
          const parser = new DOMParser();
          const svg = parser.parseFromString(data, 'image/svg+xml').querySelector('svg');
          const styleTag = svg?.querySelector('svg style');
          const styleTagString = styleTag?.innerHTML;

          // remove fill and stroke rules from svg so we can color as we need to
          const regexFill = /fill\s*:\s*(.*?);/g;
          const regexStroke = /stroke\s*:\s*(.*?);/g;
          const cleanedStyles = styleTagString?.replace(regexFill, '').replace(regexStroke, '');
          if (isDecorativeImage) {
            svg?.setAttribute('aria-hidden', 'true');
          } else {
            svg.setAttribute('aria-label', ariaLabel);
          }

          if (styleTag) {
            styleTag.innerHTML = cleanedStyles;
            styleTag.replaceWith(styleTag);
          }

          if (svg !== undefined && svg !== null) {
            imageRef.current?.appendChild(svg);
          }
        })
        .catch((error) => {
          // eslint-disable-next-line no-console
          console.error('Error:', error);
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [path, imageRef]);

  return <SvgFromFilePathWrapper className="svg-wrapper" ref={imageRef} />;
};

SvgFromFilePath.defaultProps = {
  isDecorativeImage: true,
  ariaLabel: '',
  path: ''
};

export default SvgFromFilePath;
